import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { MamFollowerModel } from 'src/app/models/mam.approval.model';
import { Permission } from 'src/app/models/permission.model';
import { NumNotRoundPipe } from 'src/app/shared/pipes/common.pipe';
import { Constants } from 'src/app/shared/utils/constants';
import { CmsService } from '../../cms.service';
import { ExcelExportService } from '../../excel.export.service';
import { getTimeRemoveTimezoneOffset } from 'src/app/shared/utils/helper';
declare var $: any;

@Component({
  selector: 'fx-mam-list',
  templateUrl: './mam-list.component.html',
  styleUrls: ['./mam-list.component.sass']
})
export class MamListComponent implements OnInit {
  permission: Permission;
  @Output() selectMAM = new EventEmitter();
  condition: any = {
    filter: 'email',
    order: 'desc',
    orderBy: ''
  };
  pageInfo: any = {
    pageIndex: 1,
    pageSize: 10,
    totalRecord: 0,
  };
  data = [];
  dataSelected;
  conditionUpdate: any = {
    group: '',
  };
  selectedType =
  [
    {
      value:'email',
      name:"Email"
    },
    {
      value:'mt5_account',
      name:"MT5 Account"
    }
  ]
  sort: any = {
    id: 'desc',
    username: 'desc',
    email: 'desc'
  };
  fixedNumber = Constants.FIXED_NUMBER;
  selectedMAM: any;
  showError = false;
  selectedMasterId:any;
  constructor(private service: CmsService, private appService: AppService,
    private decimal: NumNotRoundPipe,
    private exportService: ExcelExportService) {
    this.permission = this.appService.getCurrentPermission(location.pathname);
  }

  ngOnInit(): void {
    this.getMamFollowers();
  }
  search(event: any): void {
    if (event === 'click' || event.keyCode === 13) {
      this.pageInfo.pageIndex = 1;
      this.getMamFollowers();
    }
  }
  getMamFollowers(): void {
    const params = {
      [this.condition.filter]: (this.condition.keyword)
      ? encodeURIComponent((this.condition.keyword).trim())
      : this.condition.keyword,
      order_type: this.condition.order,
      order_by: this.getOrder(),
      page: this.pageInfo.pageIndex,
      page_size: this.pageInfo.pageSize,
    };
    this.service.getMamFollowers(params).subscribe((res) => {
      if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
        this.data = res.data;
        this.pageInfo.totalRecord = res.paging.total;
      }
    });
  }

  getOrder(): string {
    switch (this.condition.orderBy) {
      case 'id':
        return `login`;
      case 'email':
        return `email`;
      case 'username':
        return `first_name`;
      default:
        return `login`;
    }
  }

  getMamDetail(ib: any): void {
    this.selectedMAM = ib;
    this.selectMAM.emit(ib);
  }

  onRefresh(){
    this.condition.filter='email';
    this.condition.keyword='';
    this.condition.from=undefined;
    this.condition.to=undefined;
    this.showError = false;
    const params = {
      page: this.pageInfo.pageIndex,
      page_size: this.pageInfo.pageSize,
    };
    this.service.getMamFollowers(params).subscribe((res) => {
      if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
        this.data = res.data;
        this.pageInfo.totalRecord = res.paging.total;
      }
    });
  }

  getMasterId(masterId): void {
    this.selectedMasterId = masterId;
  }

  formatNumber(val): number{
    val = val.replaceAll(',','')
    return Number(val)
  }

  sorting(column: string): void {
    // tslint:disable-next-line:no-unused-expression
    this.sort[column] = this.sort[column] === 'desc' ? 'asc' : 'desc';
    this.condition.orderBy = column;
    this.condition.order = this.sort[column];
    this.getMamFollowers();
  }

  onExport(){
    if(this.condition.from && !this.condition.to || this.condition.to && !this.condition.from || this.condition.to<this.condition.from) {
      this.showError = true;
      return
    }
    this.showError = false;

    const params:any = {
      page: 1,
      page_size: 1000000,
      is_export:1
    };

    if(this.condition.from && this.condition.to){
      params.from_date=getTimeRemoveTimezoneOffset(this.condition.from);
      params.end_date=getTimeRemoveTimezoneOffset(this.condition.to);
    }
    this.service.getMamFollowers(params).subscribe((res) => {
      if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
        const customers = [];
        res.data.forEach((value : MamFollowerModel) => {
          let fixedNumber = value.currency?this.fixedNumber[value.currency]:this.fixedNumber['jpy']
          const obj = {
            'No.': value.id,
            Username: value.getUserName(),
            Email: value.email,
            'MT5 Account': value.login,
            'MT5 Group': value.currentGroup,
            'Master ID': value.masterId,
            'Total Vol':  this.decimal.transform(value.totalVolume, '1.2-2'),
            'Total Order': value.totalOrder,
            'Currency':value.currency?value.currency.toUpperCase():'',
            'Total Balance':  this.decimal.transform(value.totalBalance, fixedNumber),
            'Total PnL':  this.decimal.transform(value.totalPNL, fixedNumber),
            'Realized PnL':  this.decimal.transform(value.realizedPnl, fixedNumber),
            'Total Deposit':  this.decimal.transform(value.deposit, fixedNumber),
            'Total Withdraw':  this.decimal.transform(value.withdraw, fixedNumber),
            'Net Asset':  this.decimal.transform(value.netAsset, fixedNumber),
            'PROFIT/NET BALANCE RATIO': value.getPercentBalanceRatio(),
            'Realized PnL from Bonus': this.decimal.transform(value.totalPBB, fixedNumber),
            'Current Bonus':  this.decimal.transform(value.bonus, fixedNumber),
            'Bonus Contribution': this.decimal.transform(value.bonusContribution, fixedNumber)
          };
          customers.push(obj);
      }
    );
    const fileName = 'mam_pamm_follower';
    this.exportService.exportExcel(customers, fileName);
      }
    });
  }

  getProfitNetBalance(totalBalance, totalPNL): number {
    if (totalBalance !==  0 && totalPNL !== 0) {
      return (totalPNL / totalBalance) ;
    }
    return 0;
  }

  getMamFollowerInfo(item): void {
    this.dataSelected = item;
    this.conditionUpdate.group=item.currentGroup?item.currentGroup:'';
  }
  processCloseAll(item): void {
    this.appService
    .confirm({
      title: `Are you sure that you want to close all positions?`,
      icon: 'fa fa-question-circle',
      ok: 'Ok',
      cancel: 'Cancel',
    })
    .subscribe((res) => {
      if (res.result) {
        const body = {
          login: item.login,
        };
        this.service.processCloseAllPosition(body).subscribe((res) => {
          if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
            this.appService.showSuccess('Close all positions success');
            //$('#modalMamFollower .close').trigger('click');
          }
        });
      }
    });
  }
  processApply(): void {
    if (!this.conditionUpdate.group) {
      this.appService.showError('Please choose group');
      return;
    }
    const body = {
      group_follower: this.conditionUpdate.group,
      login: this.dataSelected.login,
    };
    this.service.updateMamFollower(body).subscribe((res) => {
      if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
        this.appService.showSuccess('Update group MAM follower success');
        $('#modalMamFollower .close').trigger('click');
        this.getMamFollowers();
      }else{
        let message=Constants.ERROR_MESSAGE[res.error_code];
        message=message.replace("{login}",this.dataSelected.login);
        message=message.replace("{group}", this.dataSelected.currentGroup);
        $('#modalMamFollower .close').trigger('click');
        this.appService.showError( message,'',true);
      }
    });
  }
  pageChanged(page: number): void {
    this.pageInfo.pageIndex = page;
    this.getMamFollowers();
  }
}
